module.exports = __webpack_public_path__ + "static/media/medicine-296966_640_color.3d8cf7b4.png";